import langAuthBarOktaBug from './features/bar-okta-bug/langs/langAuthBarOktaBug';
import langAuthDisclaimer from './features/disclaimer/langs/langAuthDisclaimer';
import langAuthLogin from './features/login/langs/langAuthLogin';
import langAuthOktaFactorQuestion from './features/okta-factor-question/langs/langAuthOktaFactorQuestion';
import langAuthOktaFactorSms from './features/okta-factor-sms/langs/langAuthOktaFactorSms';
import langAuthOktaIdx from './features/okta-idx/langs/langAuthOktaIdx';
import langAuthOktaUserActivationResend from './features/okta-user-activation-resend/langs/langAuthOktaUserActivationResend';
import langAuthOktaUserActivation from './features/okta-user-activation/langs/langAuthOktaUserActivation';
import langAuthPasswordForgot from './features/password-forgot/langs/langAuthPasswordForgot';
import langAuthPasswordReset from './features/password-reset/langs/langAuthPasswordReset';
import langAuthUserActivation from './features/user-activation/langs/langAuthUserActivation';

const AuthLangs = [
	langAuthBarOktaBug,
	langAuthLogin,
	langAuthPasswordForgot,
	langAuthPasswordReset,
	langAuthOktaUserActivationResend,
	langAuthOktaUserActivation,
	langAuthOktaIdx,
	langAuthOktaFactorQuestion,
	langAuthOktaFactorSms,

	langAuthDisclaimer,
	langAuthUserActivation,
];

export default AuthLangs;
